export default function initVideoPlayMarca() {
    const videoContainers = document.querySelectorAll('.js-video-container');

    if (!videoContainers.length) return;

    videoContainers.forEach(container => {
        const playBtn = container.querySelector('.js-video-play');
        const iframeWrap = container.querySelector('.js-video-iframe-wrap');
        const iframe = container.querySelector('iframe');

        if (!playBtn || !iframe) return;

        playBtn.addEventListener('click', () => {
            // 1. Esconde o botão play customizado
            playBtn.style.opacity = '0';
            playBtn.style.pointerEvents = 'none';

            // 2. Libera o ponteiro do mouse para o usuário poder pausar/mexer no vídeo
            iframe.style.pointerEvents = 'auto';

            // 3. Força o autoplay no iframe do YouTube/Vimeo
            let src = iframe.getAttribute('src');

            // Checa se já tem parâmetros na URL do iframe
            if (src.indexOf('?') > -1) {
                src += '&autoplay=1';
            } else {
                src += '?autoplay=1';
            }

            // O YouTube pede mute para autoplay em alguns navegadores, mas como é interação de clique, costuma funcionar sem mute.
            iframe.setAttribute('src', src);
        });
    });
}